import { Link, NavLink } from "react-router-dom";
import { NAV, BRAND } from "../lib/content";
import { useState } from "react";
import { Menu, X } from "lucide-react";

export default function SiteHeader() {
  const [open, setOpen] = useState(false);

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-40 border-b border-white/10 backdrop-blur-xl bg-black/70"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-10 h-16 flex items-center justify-between">
        <Link
          to="/"
          data-testid="logo-link"
          className="flex items-center gap-3"
        >
          <img
            src={BRAND.logoIcon}
            alt={BRAND.company}
            className="h-10 w-auto object-contain"
          />
          <div className="flex flex-col leading-none">
            <span className="font-display font-black text-sm tracking-tight">
              LOGARITHMIC<span className="text-[#FF3B30]">TECH</span>
            </span>
            <span className="hidden md:inline font-mono-tech text-[9px] uppercase tracking-[0.25em] text-white/50 mt-1">
              Driving What&apos;s Next
            </span>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-7">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/"}
              data-testid={`nav-${item.label.toLowerCase()}`}
              className={({ isActive }) =>
                `font-mono-tech text-[11px] uppercase tracking-[0.18em] u-link transition-colors ${
                  isActive ? "text-white" : "text-white/60 hover:text-white"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <Link
            to="/contact"
            data-testid="header-cta-briefing"
            className="inline-flex items-center gap-2 bg-[#FF3B30] hover:bg-[#FF5C53] text-white font-mono-tech uppercase tracking-widest text-[11px] px-5 py-3 transition-colors"
          >
            Request briefing
          </Link>
        </div>

        <button
          type="button"
          onClick={() => setOpen((o) => !o)}
          className="lg:hidden p-2 -mr-2 text-white"
          data-testid="mobile-menu-toggle"
          aria-label="Toggle menu"
        >
          {open ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>

      {open && (
        <div
          className="lg:hidden border-t border-white/10 bg-black"
          data-testid="mobile-menu"
        >
          <div className="px-6 py-5 flex flex-col gap-4">
            {NAV.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-${item.label.toLowerCase()}`}
                className={({ isActive }) =>
                  `font-mono-tech text-xs uppercase tracking-[0.2em] ${
                    isActive ? "text-white" : "text-white/60"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
            <Link
              to="/contact"
              onClick={() => setOpen(false)}
              data-testid="mobile-cta-briefing"
              className="mt-2 inline-flex items-center justify-center bg-[#FF3B30] text-white font-mono-tech uppercase tracking-widest text-xs px-5 py-3"
            >
              Request briefing
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
